"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactRedux = require("react-redux");

var _TimeSlotSelector = require("../../components/steps/TimeSlotSelector");

var _TimeSlotSelector2 = _interopRequireDefault(_TimeSlotSelector);

var _timeslot = require("../../actions/timeslot");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadBookingTimes: function loadBookingTimes(serviceIds, garageId) {
      dispatch((0, _timeslot.loadBookingTimes)(serviceIds, garageId));
    }
  };
}

function mapStateToProps(state) {
  var formData = state.formData,
      timeslot = state.timeslot;
  var serviceIds = formData.serviceIds,
      garageId = formData.garageId,
      day = formData.day,
      hour = formData.hour,
      minute = formData.minute;
  var availableTimes = timeslot.availableTimes,
      isLoadingBookingTimes = timeslot.isLoadingBookingTimes,
      loadBookingTimesError = timeslot.loadBookingTimesError;
  return {
    serviceIds: serviceIds,
    garageId: garageId,
    day: day,
    hour: hour,
    minute: minute,
    availableTimes: availableTimes,
    isLoadingBookingTimes: isLoadingBookingTimes,
    loadBookingTimesError: loadBookingTimesError
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps, {
    loadBookingTimes: function loadBookingTimes() {
      return dispatchProps.loadBookingTimes(stateProps.serviceIds, stateProps.garageId);
    }
  });
}

var TimeSlotSelectorContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_TimeSlotSelector2.default);
exports.default = TimeSlotSelectorContainer;